if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      // comment this in for js fetch of swatch product into current product card
      // this.handleProductCardSwatchClick();
      this.querySelector(".card__main-content").addEventListener(
        "click",
        (event) => {
          const slider = this.closest(".ugc-products-slider");

          if (this.classList.contains("product-card-wrapper--expandable")) {
            if (!this.classList.contains("product-card-wrapper--expanded")) {
              event.preventDefault();
              event.stopPropagation();

              document
                .querySelectorAll(".product-card-wrapper")
                .forEach((el) => {
                  el.classList.remove("product-card-wrapper--expanded");
                });
            }

            const slide = this.closest(".splide__slide");

            if (slide.classList.contains("is-active")) {
              this.classList.add("product-card-wrapper--expanded");
            } else {
              if (slider) {
                slider.dispatchEvent(
                  new CustomEvent("goToSlide", {
                    detail: slide.getAttribute("data-slide-index"),
                  })
                );
              }

              this.classList.add("product-card-wrapper--expanded");
            }
          }
        }
      );
    }

    handleInsideLinkClick = (event) => {
      event.preventDefault();
    };

    fetchProduct(event) {
      event.preventDefault();

      const isWithinSlider = this.closest("slider-component") !== null;
      const isWithinCartDrawer = this.closest("#CartDrawer") !== null;
      const isProductPage = document.body.classList.contains("product");
      const isMobile = window.innerWidth < 750;

      /*
        if ((isWithinSlider && isProductPage && isMobile) || (isWithinSlider && isWithinCartDrawer && isMobile)) {
          return
        }
      */

      fetch(event.target.dataset.productUrl + "?view=card-product--swatches")
        .then((response) => response.text())
        .then((text) => {
          const newHtml = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("product-card").innerHTML;

          if (newHtml !== null) {
            this.innerHTML = newHtml;
            this.handleProductCardSwatchClick();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    handleProductCardSwatchClick() {
      const swatches = this.querySelectorAll(
        "product-group product-group-swatch"
      );
      swatches.forEach((swatch) => {
        swatch.addEventListener("click", this.fetchProduct.bind(this));
        swatch.querySelector("a.product-group--item")?.classList.add("js-load");
        swatch
          .querySelector("a.product-group--item")
          ?.addEventListener("click", this.handleInsideLinkClick);
      });
    }
  }

  customElements.define("product-card", ProductCard);
}
